module.exports = __webpack_public_path__ + "img/police_icon.d0289dc0.d0289dc0.png";